import * as AWSFireHose from "aws-sdk/clients/firehose";

export default class FireHose {
    private static firehose: AWSFireHose;
    protected static streamName: string;
    protected static accessKeyId = "AKIA3LYTRGGTRT3EBOXZ";
    protected static secretAccessKey = "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";

    public init(streamName?: string, accessKeyId?: string, secretAccessKey?: string): void {
        if (streamName) { FireHose.streamName = streamName; }
        if (accessKeyId) { FireHose.accessKeyId = accessKeyId; }
        if (secretAccessKey) { FireHose.secretAccessKey = secretAccessKey; }

        FireHose.firehose = new AWSFireHose({
            params: {
                DeliveryStreamName: FireHose.streamName
            },
            accessKeyId: FireHose.accessKeyId,
            secretAccessKey: FireHose.secretAccessKey,
            region: "us-east-1"
        });
    }
    public async put(log: any): Promise<any> {
        if (!FireHose.firehose) {
            this.init();
        }

        FireHose.firehose.putRecordBatch({
            DeliveryStreamName: FireHose.streamName,
            Records: [{
                Data: JSON.stringify(log) + "\n"
            }]
        }, (err, data) => {
            console.log(err, data);
        });
    }
}
